import React from "react";
import { useCommonDialogContext } from "../CommonDialogContext";

export const withCommonDialogContext = Component => props => {
    const commonDialogContext = useCommonDialogContext();
    return <Component {...props} commonDialogContext={commonDialogContext} />;
};
